async function init() {
    await import('@webapp/core/main');
}
init();